import React, {useState} from 'react';
import { Icon } from 'semantic-ui-react';
import { useKeenSlider } from 'keen-slider/react'

import './photo-dimmer.scss';

const PhotoDimmer = ({allPictures, handleClick, currentIndex }) => {
  const [currentSlide, setCurrentSlide] = useState(currentIndex);
  const [sliderRef, slider] = useKeenSlider({
    initial: currentIndex,
    spacing: 15,
    slideChanged(s) {
      setCurrentSlide(s.details().relativeSlide);
    },
  });
  
  return (
    <>
    <Icon onClick={handleClick} name='close' className="fixed-icon-close" />
    <div className="photo-dimmer navigation-wrapper">
      <div ref={sliderRef} className="keen-slider">
        {allPictures.map(photo => (
          <div key={photo.id} className={`keen-slider__slide dimmer-container-image picture-${photo.customclass}`}>
            <div className="position-img">
              <img src={photo.fullsize}/>
            </div>
          </div>
        ))}
      </div>
    </div>

    {slider && (
      <div className="dots">
        {[...Array(slider.details().size).keys()].map(idx => {
          return (
            <button
              key={idx}
              onClick={() => {
                slider.moveToSlideRelative(idx);
              }}
              className={"dot" + (currentSlide === idx ? " active" : "")}
            />
          );
        })}
      </div>
    )}
    </>
  );
};

export default PhotoDimmer;
